import React from 'react';
import { SvgIcon, SxProps, Theme } from '@mui/material';
import { ReactComponent as HomeIconSVG } from './home-icon.svg';
import { ReactComponent as InboxIconSVG } from './inbox-icon.svg';
import { ReactComponent as ReceiptsIconSVG } from './receipts-icon.svg';
import { ReactComponent as ReportsIconSVG } from './reports-icon.svg';
import { ReactComponent as SettingsIconSVG } from './settings-icon.svg';
import { ReactComponent as GoogleIconSVG } from './google-icon.svg';
import { ReactComponent as InfoIconSVG } from './info-icon.svg';
import { ReactComponent as XIconSVG } from './x-icon.svg';

export type IconProps = {
  color?: 'inherit' | 'primary' | 'secondary' | 'action' | 'disabled' | 'error';
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
  className?: string;
  classes?: any;
  id?: string;
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  viewBox?: string;
};

const createMaterialIcon = (
  Icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >,
) =>
  React.memo((props: IconProps) => {
    return (
      <SvgIcon {...props}>
        <Icon />
      </SvgIcon>
    );
  });

export const HomeIcon = createMaterialIcon(HomeIconSVG);
export const InboxIcon = createMaterialIcon(InboxIconSVG);
export const ReceiptsIcon = createMaterialIcon(ReceiptsIconSVG);
export const ReportsIcon = createMaterialIcon(ReportsIconSVG);
export const SettingsIcon = createMaterialIcon(SettingsIconSVG);
export const GoogleIcon = createMaterialIcon(GoogleIconSVG);
export const InfoIcon = createMaterialIcon(InfoIconSVG);
export const XIcon = createMaterialIcon(XIconSVG);
